import React, {Component} from 'react'
import {
  Flex,
  Box,
  FormControl,
  FormLabel,
  Input,
  Stack,
  Link,
  Button,
  Heading,
  Text,
  VStack,
  Image,
  Alert,
  AlertIcon,
  AlertDescription,
  PinInput,
  PinInputField,
  HStack,
} from '@chakra-ui/react'
import colors from '../../theme/colors'

class PasswordResetConfirm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      email: '',
      code: '',
      password: '',
      confirmPassword: '',
      isSubmitting: false,
      error: '',
      success: false
    }
  }

  handleEmailChange = (value) => {
    this.setState({ email: value, error: '' })
  }

  handleCodeChange = (value) => {
    this.setState({ code: value, error: '' })
  }

  handlePasswordChange = (value) => {
    this.setState({ password: value, error: '' })
  }

  handleConfirmPasswordChange = (value) => {
    this.setState({ confirmPassword: value, error: '' })
  }

  handleSubmit = async () => {
    const { email, code, password, confirmPassword } = this.state

    // Validation
    if (!email || !code || !password || !confirmPassword) {
      this.setState({ error: 'Alle velden zijn verplicht.' })
      return
    }

    if (code.length !== 6) {
      this.setState({ error: 'De resetcode moet 6 cijfers bevatten.' })
      return
    }

    if (password !== confirmPassword) {
      this.setState({ error: 'Wachtwoorden komen niet overeen.' })
      return
    }

    if (password.length < 8) {
      this.setState({ error: 'Wachtwoord moet minimaal 8 karakters bevatten.' })
      return
    }

    this.setState({ isSubmitting: true, error: '' })

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL || ''}/reset-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        credentials: 'include',
        body: JSON.stringify({
          email,
          code,
          password
        })
      })

      const data = await response.json()

      if (data.success) {
        this.setState({
          success: true,
          isSubmitting: false
        })
        // Auto-redirect to login after 2 seconds
        setTimeout(() => {
          this.props.onRouteChange('login')
        }, 2000)
      } else {
        this.setState({
          error: data.message || 'Er is een fout opgetreden.',
          isSubmitting: false
        })
      }
    } catch (error) {
      console.error('Error:', error)
      this.setState({
        error: 'Kan geen verbinding maken met de server.',
        isSubmitting: false
      })
    }
  }

  render() {
    const { error, success, isSubmitting, code } = this.state

    return (
      <Flex
        minH={'100vh'}
        align={'center'}
        justify={'center'}
        bg={colors.background.main}
        position="relative"
      >
        <Box bg={colors.primary.main} h="160px" w="100%" position="absolute" top="0">
          <VStack justify="center" h="100%" spacing={4}>
            <Image src="/volt_logo.png" boxSize="80px" alt="Demos Platform Logo" />
          </VStack>
        </Box>
        <Stack spacing={8} mx={'auto'} maxW={'lg'} w={{ base: '95%', sm: 'auto' }} py={12} px={{ base: 4, sm: 6 }} position="relative" zIndex="1" mt="120px">
          <VStack spacing={4} align={'center'}>
            <Heading fontSize={{ base: '3xl', sm: '4xl' }} textAlign="center">
              <Text as="span" color={colors.text.primary}>Wachtwoord </Text>
              <Text as="span" color={colors.primary.main}>Resetten</Text>
            </Heading>
            <Text fontSize={{ base: 'md', sm: 'lg' }} color={colors.text.secondary} textAlign="center" px={4}>
              Voer de code in die je via email hebt ontvangen
            </Text>
          </VStack>
          <Box
            rounded={'lg'}
            bg={colors.background.white}
            boxShadow={'lg'}
            p={{ base: 6, sm: 8 }}>
            {success ? (
              <VStack spacing={4}>
                <Alert status="success" borderRadius="md">
                  <AlertIcon />
                  <AlertDescription>
                    Wachtwoord succesvol gewijzigd! Je wordt doorgestuurd naar de login pagina...
                  </AlertDescription>
                </Alert>
              </VStack>
            ) : (
              <Stack spacing={4}>
                {error && (
                  <Alert status="error" borderRadius="md">
                    <AlertIcon />
                    <AlertDescription>{error}</AlertDescription>
                  </Alert>
                )}
                <FormControl id="email">
                  <FormLabel>Email</FormLabel>
                  <Input
                    type="email"
                    placeholder="je@email.nl"
                    bg={colors.form.inputBg}
                    onChange={(event) => this.handleEmailChange(event.target.value)}
                  />
                </FormControl>
                <FormControl id="code">
                  <FormLabel>Resetcode (6 cijfers)</FormLabel>
                  <HStack justify="center" spacing={{ base: 1, sm: 2 }}>
                    <PinInput
                      otp
                      size={{ base: "md", sm: "lg" }}
                      value={code}
                      onChange={this.handleCodeChange}
                    >
                      <PinInputField bg={colors.form.inputBg} />
                      <PinInputField bg={colors.form.inputBg} />
                      <PinInputField bg={colors.form.inputBg} />
                      <PinInputField bg={colors.form.inputBg} />
                      <PinInputField bg={colors.form.inputBg} />
                      <PinInputField bg={colors.form.inputBg} />
                    </PinInput>
                  </HStack>
                </FormControl>
                <FormControl id="password">
                  <FormLabel>Nieuw Wachtwoord</FormLabel>
                  <Input
                    type="password"
                    placeholder="Minimaal 8 karakters"
                    bg={colors.form.inputBg}
                    onChange={(event) => this.handlePasswordChange(event.target.value)}
                  />
                </FormControl>
                <FormControl id="confirmPassword">
                  <FormLabel>Bevestig Wachtwoord</FormLabel>
                  <Input
                    type="password"
                    placeholder="Herhaal je wachtwoord"
                    bg={colors.form.inputBg}
                    onChange={(event) => this.handleConfirmPasswordChange(event.target.value)}
                  />
                </FormControl>
                <Stack spacing={10}>
                  <Button
                    bg={colors.button.primary}
                    color={colors.text.white}
                    _hover={{
                      bg: colors.button.primaryHover,
                    }}
                    _active={{
                      bg: colors.button.primaryActive,
                    }}
                    onClick={this.handleSubmit}
                    isLoading={isSubmitting}
                    loadingText="Resetten...">
                    Wachtwoord Resetten
                  </Button>
                  <VStack spacing={2}>
                    <Link
                      color={colors.text.link}
                      fontSize={'sm'}
                      fontWeight="600"
                      textDecoration="underline"
                      onClick={() => this.props.onRouteChange('passwordResetRequest')}
                      cursor="pointer"
                      _hover={{ color: colors.text.linkHover }}
                    >
                      Nieuwe code aanvragen
                    </Link>
                    <Link
                      color={colors.text.link}
                      fontSize={'sm'}
                      fontWeight="600"
                      textDecoration="underline"
                      onClick={() => this.props.onRouteChange('login')}
                      cursor="pointer"
                      _hover={{ color: colors.text.linkHover }}
                    >
                      Terug naar Inloggen
                    </Link>
                  </VStack>
                </Stack>
              </Stack>
            )}
          </Box>
        </Stack>
      </Flex>
    )
  }
}

export default PasswordResetConfirm
